"use strict";
exports.__esModule = true;
exports.setLifecycleConfig = exports.onPageClose = exports.onPageOpen = void 0;
var logger_1 = require("../logger");
var session_1 = require("./session");
var reportWebPageOpen_1 = require("./reportWebPageOpen");
var grapheneMetrics_1 = require("../grapheneMetrics");
var log = (0, logger_1.getLogger)("lifecycle");
var isFirstResume = true;
function onPageOpen(props) {
    var _a;
    var _b;
    var isFocused = (_b = props === null || props === void 0 ? void 0 : props.hasFocus) !== null && _b !== void 0 ? _b : document.hasFocus();
    log.info("Blizzard - #onOpen", isFirstResume ? "(cold start)" : "(warm start)", isFocused ? "(foreground)" : "(background)");
    grapheneMetrics_1.blizzardGraphene.increment({
        metricsName: grapheneMetrics_1.ON_OPEN,
        dimensions: (_a = {},
            _a[grapheneMetrics_1.STARTUP_TYPE] = isFirstResume ? "cold" : "warm",
            _a[grapheneMetrics_1.FOCUSED] = "".concat(isFocused),
            _a)
    });
    if (isFirstResume) {
        isFirstResume = false;
    }
    else {
        (0, session_1.startNewSession)("WARM");
    }
    if (lifecycleConfig.reportWebPageOpen) {
        if (isFocused) {
            (0, reportWebPageOpen_1.reportWebPageOpen)(props || {});
        }
    }
}
exports.onPageOpen = onPageOpen;
function onPageClose() {
    var _a;
    var _b, _c;
    log.info("Blizzard - #onClose");
    grapheneMetrics_1.blizzardGraphene.increment({
        metricsName: grapheneMetrics_1.ON_CLOSE,
        dimensions: (_a = {},
            _a[grapheneMetrics_1.STARTUP_TYPE] = (_c = (_b = (0, session_1.getSessionProperties)()) === null || _b === void 0 ? void 0 : _b.appStartupType) !== null && _c !== void 0 ? _c : "",
            _a)
    });
}
exports.onPageClose = onPageClose;
var lifecycleConfig = {};
function setLifecycleConfig(config) {
    lifecycleConfig = config;
}
exports.setLifecycleConfig = setLifecycleConfig;
//# sourceMappingURL=index.js.map